import { render, staticRenderFns } from "./annual-sales-performance.page.vue?vue&type=template&id=55af0c58"
import script from "./annual-sales-performance.page.vue?vue&type=script&lang=ts"
export * from "./annual-sales-performance.page.vue?vue&type=script&lang=ts"
import style0 from "./annual-sales-performance.page.vue?vue&type=style&index=0&id=55af0c58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports